import React, { Component } from 'react';
import SVideoAds from 'shared/screens/VideoAds';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import styled, { ThemeContext } from 'styled-components';
import CollectButton from './components/CollectButton';
import { DefaultHeaderResultStyle, HeaderContainer, HeaderHeight, wrapperStyle } from './components/styledComponents';
import CongratsHeader from './components/WatchAndEarnHeader';
import './VideoAds.scss';

export default class Congrats extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-watchAndEarn-Congrats',
      hideBeforeSelector: ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'hri',
    };
  }

  state = {
    hasSeenCongratsModal: true,
  };

  componentDidMount() {
    window.history.replaceState('', '', window.location.origin);
  }

  render() {
    const themeContext = this.context;
    return (
      <SVideoAds
        navigation={this.props.navigation}
        render={props => {
          const { reward, collectHandler, setHasSeenCongratsModal } = props;
          if (this.state.hasSeenCongratsModal) {
            setHasSeenCongratsModal(true);
          }
          return (
            <div className="watchAndEarnCongratsContainer">
              <CongratsHeader
                headerTitleWrapperStyle={DefaultHeaderResultStyle}
                headerHeightStyle={HeaderHeight}
                wrapperStyle={wrapperStyle}
                containerStyle={HeaderContainer}
                title={getText(TEXT_KEY.CONGRATULATIONS)}
              />
              <span className="watchAndEarnPopupIcon">
                <CoinIcon alt={getText(TEXT_KEY.COINS)} />
              </span>
              <span style={themeContext.CongratulationsContainer.CongratsSpan}>
                {getText(TEXT_KEY.YOU_HAVE_EARNED)}
              </span>
              <AmountWrapper>
                <CoinIconSmall alt={getText(TEXT_KEY.COINS)} />
                <AmountTextWrapper
                  data-label={reward.amount}
                  className={`watchAndEarnGradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                >
                  {reward.amount}
                </AmountTextWrapper>
              </AmountWrapper>
              <CollectButton
                containerStyle={styles.collectButtonContainer}
                imageStyle={styles.collectButtonImage}
                textStyle={styles.collectButtonText}
                label={getText(TEXT_KEY.COLLECT_BUTTON)}
                onClick={() => collectHandler(true)}
              />
            </div>
          );
        }}
      />
    );
  }
}

Congrats.hideOverlay = true;
Congrats.hideCloseButton = true;
Congrats.contextType = ThemeContext;

const CoinIcon = styled.img.attrs(() => ({
  src: assetSource(ASSET_KEY.COINS_TEX),
}))`
  width: 100%;
  height: 100%;
`;

const CoinIconSmall = styled.img.attrs(() => ({
  src: assetSource(ASSET_KEY.COIN_ICON),
}))`
  width: 30px;
  height: 30px;
  margin-top: 0.2em;
  margin-right: 0.3em;
  object-fit: contain;
`;

const AmountWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 3em;
`;

const AmountTextWrapper = styled.span`
  font-size: 1.5em;
  font-weight: 600;
`;

const styles = {
  collectButtonContainer: {
    position: 'relative',
    textAlign: 'center',
    cursor: 'pointer',
    pointerEvents: 'auto',
    alignSelf: 'center',
    minHeight: '3em',
    width: '11em',
  },
  collectButtonImage: {
    width: '100%',
    height: '100%',
  },
  collectButtonText: {
    fontSize: 20,
    padding: 0,
  },
};

